import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap'
createApp(App).mount('#app')
